import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
// import 'react-select/dist/react-select.css';

class SelectSearchContainer extends React.Component {
    constructor(props) {
        super(props);

        // TODO: I'm not sure this component even uses state
        this.state = { options: [] };

        this.mapOptions = this.mapOptions.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    mapOptions(optionsArr, labelColumn, valueColumn) {
        const mappedOptions = optionsArr.map(option => {
            return {
                label: option[labelColumn],
                value: option[valueColumn]
            };
        });
        return mappedOptions;
    }

    handleChange(e) {
        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    render() {
        return (
            <Select
                options={this.mapOptions(
                    this.props.options,
                    this.props.labelColumn,
                    this.props.valueColumn
                )}
                searchable={true}
                onChange={this.handleChange}
                value={this.props.value}
                id={this.props.id || 'react-select'}
                matchPos={'start'}
                ignoreAccents={true}
                placeholder={this.props.placeHolder ? this.props.placeHolder : "Select Brokerage..."}
            />
        );
    }
}

export default SelectSearchContainer;
